var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _circle, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationCargoPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5V9.61328C8 7.40414 9.79086 5.61328 12 5.61328H31.3865C33.5956 5.61328 35.3865 7.40414 35.3865 9.61328V28.9998C35.3865 31.2089 33.5956 32.9998 31.3865 32.9998H17",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7461 3.14258L14.7461 5.27264",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3506 3.14258L29.3506 5.27264",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1152 19.1025H15.1009",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2002 19.1025H21.1859",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2002 24.1748H21.1859",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2861 19.1025H27.2718",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2861 24.1748H27.2718",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.91406,
    y1: 12.5791,
    x2: 34.4748,
    y2: 12.5791,
    stroke: "white",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.71429,
    cy: 26.7143,
    r: 7.71429,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49414 30.9965C6.78929 30.9718 7.05931 30.8206 7.23449 30.5818L11.4892 24.7815C11.8236 24.3257 11.7251 23.6851 11.2692 23.3507C10.8134 23.0163 10.1728 23.1148 9.83837 23.5706L6.27952 28.4223L4.7374 26.9223C4.33215 26.5281 3.68406 26.537 3.28987 26.9423C2.89568 27.3476 2.90465 27.9956 3.30991 28.3898L5.69534 30.7101C5.90765 30.9166 6.19899 31.0211 6.49414 30.9965Z",
    fill: "#06CEA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCargoPositive);
export default __webpack_public_path__ + "static/media/notification-cargo-positive.ad7d7c4ccdbf1c44ba7670dfc6ea94e7.svg";
export { ForwardRef as ReactComponent };